var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "plus_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 14.25a.72.72 0 0 1-.534-.216.72.72 0 0 1-.216-.534V9.75H4.5a.73.73 0 0 1-.535-.216A.73.73 0 0 1 3.75 9q0-.319.215-.535A.73.73 0 0 1 4.5 8.25h3.75V4.5q0-.318.216-.535A.73.73 0 0 1 9 3.75q.319 0 .535.215a.73.73 0 0 1 .215.535v3.75h3.75q.319 0 .534.215A.73.73 0 0 1 14.25 9q0 .319-.216.534a.72.72 0 0 1-.534.216H9.75v3.75q0 .319-.215.534A.73.73 0 0 1 9 14.25"
  }))));
};
export default SvgPlus;